"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formRuleSetForCompetitorProducts = formRuleSetForCompetitorProducts;
exports.formRuleSetForCompetitorProductsV0 = formRuleSetForCompetitorProductsV0;
exports.formRuleSetForCompetitorProduct = formRuleSetForCompetitorProduct;
exports.modifyRuleSetForCompetitorProducts = modifyRuleSetForCompetitorProducts;
exports.areAllCompetitorProductsResolved = areAllCompetitorProductsResolved;
exports.findResolvedProducts = findResolvedProducts;

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _unionWith = _interopRequireDefault(require("lodash/unionWith"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _map = _interopRequireDefault(require("lodash/map"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _keyBy = _interopRequireDefault(require("lodash/keyBy"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _some = _interopRequireDefault(require("lodash/some"));

var _constants = require("./constants");

function formRuleSetForCompetitorProducts(competitorProducts, mcpRuleSet) {
  var ruleSet = {
    id: 'competitorProducsRuleSetId',
    referenceId: '',
    authoritative: false
  };
  var whiteList = [];
  var whiteListObject = {};
  var competitorProductsClone = (0, _cloneDeep["default"])(competitorProducts);
  (0, _forEach["default"])(competitorProductsClone, function (competitorProduct) {
    (0, _forEach["default"])(competitorProduct.whiteList, function (attribute) {
      if (!(0, _some["default"])(mcpRuleSet.whiteList, function (mcpAttribute) {
        return mcpAttribute.attributeKey.toLowerCase() === attribute.attributeKey.toLowerCase();
      })) {
        attribute.type = _constants.attributeType.listOfValues;
        attribute.required = true;

        if (!whiteListObject[attribute.attributeKey]) {
          whiteListObject[attribute.attributeKey] = attribute;
          whiteList.push(whiteListObject[attribute.attributeKey]);
        } else {
          whiteListObject[attribute.attributeKey].attributeValues = (0, _unionWith["default"])(whiteListObject[attribute.attributeKey].attributeValues, attribute.attributeValues, _isEqual["default"]);
        }
      }
    });
  });
  ruleSet.whiteList = whiteList;
  return ruleSet;
}

function formRuleSetForCompetitorProductsV0(competitorProducts) {
  var ruleSet = {
    id: 'competitorProducsRuleSetId',
    referenceId: '',
    authoritative: false
  };
  var whiteList = [];
  var whiteListObject = {};
  var competitorProductsClone = (0, _cloneDeep["default"])(competitorProducts);
  (0, _forEach["default"])(competitorProductsClone, function (competitorProduct) {
    (0, _forEach["default"])(competitorProduct.whiteList, function (attribute) {
      attribute.type = _constants.attributeType.listOfValues;
      attribute.required = true;

      if (!whiteListObject[attribute.attributeKey]) {
        whiteListObject[attribute.attributeKey] = attribute;
        whiteList.push(whiteListObject[attribute.attributeKey]);
      } else {
        whiteListObject[attribute.attributeKey].attributeValues = (0, _unionWith["default"])(whiteListObject[attribute.attributeKey].attributeValues, attribute.attributeValues, _isEqual["default"]);
      }
    });
  });
  ruleSet.whiteList = whiteList;
  return ruleSet;
}

function formRuleSetForCompetitorProduct(competitorProduct) {
  var ruleSet = {
    id: competitorProduct.name,
    referenceId: competitorProduct.name,
    authoritative: false
  };
  var whiteList = [];
  var competitorProductClone = (0, _cloneDeep["default"])(competitorProduct);
  (0, _forEach["default"])(competitorProductClone.whiteList, function (attribute) {
    attribute.type = _constants.attributeType.listOfValues;
    attribute.required = true;
    whiteList.push(attribute);
  });
  ruleSet.whiteList = whiteList;

  if (competitorProduct.rules) {
    ruleSet.rules = competitorProduct.rules;
  }

  return ruleSet;
}

function modifyRuleSetForCompetitorProducts(mcpRuleSet, competitorProducts) {
  var ruleSet = {
    id: 'competitorProducsRuleSetId',
    referenceId: '',
    authoritative: false
  };
  var whiteList = [];
  var mcpRuleSetClone = (0, _cloneDeep["default"])(mcpRuleSet);
  var competitorProductsClone = (0, _cloneDeep["default"])(competitorProducts);
  var whiteListObject = (0, _keyBy["default"])(mcpRuleSet.whiteList, function (attribute) {
    return attribute.attributeKey;
  });
  (0, _forEach["default"])(competitorProductsClone, function (competitorProduct) {
    (0, _forEach["default"])(competitorProduct.whiteList, function (attribute) {
      attribute.type = _constants.attributeType.listOfValues;
      attribute.required = true;

      if (!whiteListObject[attribute.attributeKey]) {
        whiteListObject[attribute.attributeKey] = attribute;
        mcpRuleSetClone.whiteList.push(whiteListObject[attribute.attributeKey]);
      } else {
        whiteListObject[attribute.attributeKey].attributeValues = (0, _unionWith["default"])(whiteListObject[attribute.attributeKey].attributeValues, attribute.attributeValues, _isEqual["default"]);
      }
    });
  });
  ruleSet.whiteList = whiteList;
  return ruleSet;
}

function areAllCompetitorProductsResolved(competitorProductsStates, competitorProductsRuleSets) {
  return !(0, _some["default"])(competitorProductsRuleSets, function (competitorProductsRuleSet) {
    return !competitorProductsStates[competitorProductsRuleSet.id] || competitorProductsStates[competitorProductsRuleSet.id].state !== _constants.productState.fullyResolved;
  });
}

function findResolvedProducts(competitorProducts, attributes) {
  var resolvedCompetitorProductsList = {};
  var resolvedAttributesKeyValue = (0, _keyBy["default"])((0, _filter["default"])(attributes, function (attribute) {
    return attribute.resolvedValue;
  }), function (resolvedAttribute) {
    return resolvedAttribute.key;
  });
  (0, _forEach["default"])(competitorProducts, function (competitorProduct) {
    resolvedCompetitorProductsList[competitorProduct.name] = {
      state: '',
      // Change it to enum
      attributes: []
    };
    var resolvedAttributes = [];
    (0, _filter["default"])(competitorProduct.whiteList, function (attribute) {
      if (resolvedAttributesKeyValue[attribute.attributeKey] && (0, _map["default"])(attribute.attributeValues, function (attributeValue) {
        return attributeValue.value;
      }).includes(resolvedAttributesKeyValue[attribute.attributeKey].resolvedValue)) {
        resolvedAttributes.push(resolvedAttributesKeyValue[attribute.attributeKey]);
      }
    });

    if (resolvedAttributes.length === competitorProduct.whiteList.length) {
      resolvedCompetitorProductsList[competitorProduct.name].state = _constants.productState.fullyResolved;
      resolvedCompetitorProductsList[competitorProduct.name].attributes = resolvedAttributes;
    } else {
      resolvedCompetitorProductsList[competitorProduct.name].state = _constants.productState.partiallyResolved;
      resolvedCompetitorProductsList[competitorProduct.name].attributes = resolvedAttributes;
    }
  });
  return resolvedCompetitorProductsList;
}